<template>
  <div style="text-align:center;">
    <table border="1">
      <!-- 第1行(1表) -->
      <tr style="height:100px">
        <td width="30%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="40%" colspan="2" class="titleSpan tableTitle">现 场 勘 察 记 录</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
      <!-- 第2行(1表) -->
      <tr style="height:50px">
        <td width="30%" class="titleSpan">项目名称</td>
        <td colspan="3" class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第3行(1表) -->
      <tr style="height:50px">
        <td width="30%" class="titleSpan">现场检查地点</td>
        <td width="22%" class="contentSpan">tewadsasdas</td>
        <td width="18%" class="titleSpan">检查时间</td>
        <td class="contentSpan">2022-05-05</td>
      </tr>
      <!-- 第4行(1表) -->
      <tr style="height:50px">
        <td width="30%" class="titleSpan">检查人员</td>
        <td colspan="3" class="contentSpan">{{printData.company_name}}</td>
      </tr>
    </table>

    <table border="1" style="border-top:0">
      <tr style="height:100px">
        <td width="8%" class="titleSpan">
          <div style="padding:0;20px">现场情况记录</div>
        </td>
        <td colspan="3" class="contentSpan">
          <div
            style="min-height:100px;box-sizing:border-box;padding:5px;text-align:left"
          >{{printData.company_name}}</div>
        </td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:100px">
        <td colspan="4" style="text-align:left;">
          <div style="min-height:100px;box-sizing:border-box;padding:10px;" class="wirteTableRow">
            <div class="pic">
              <div>现场勘察人员签字:</div>
              <img src="../../assets/image/icon_MP4@2x.png" alt />
            </div>
            <div>年月日</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>